import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RangeTableComponent } from './range-table.component';



@NgModule({
  declarations: [
    RangeTableComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    RangeTableComponent,
  ]
})
export class RangeTableModule { }
